import { useQuery } from 'react-query';

import * as Api from '../api';
import * as Constants from '../constants';
import * as Mappers from '../mappers';

const usePercentage = () => {
  const initialData = { item: Mappers.Percentage() };

  const { data = initialData, ...args } = useQuery(
    [Constants.ENTITY, 'percentage'],
    async () => {
      const { data } = await Api.Percentage();

      return {
        item: Mappers.Percentage(data && data.data)
      };
    },
    { initialData }
  );

  return { ...args, ...data };
};

export default usePercentage;
